import "./App.css";
import "react-tooltip/dist/react-tooltip.css";

import Gravatar from "react-gravatar";
import { FaLinkedin } from "react-icons/fa";
import { FiInstagram } from "react-icons/fi";
import { AiOutlineGithub, AiOutlineMail } from "react-icons/ai";
import { RiSeparator } from "react-icons/ri";
import { TbApi } from "react-icons/tb";
import { Tooltip } from "react-tooltip";

function App() {
  if (window.location.pathname.replace(/\/$/, "") === "/resume") {
    return (
      <main className="resume-page">
        <iframe
          className="resume-viewer"
          src="/resume.pdf"
          title="Jon Maciel Resume"
        />
      </main>
    );
  }

  return (
    <div className="App">
      <Tooltip id="my-tooltip" />

      <div className="cover"></div>
      <Gravatar
        className="App-logo"
        size={170}
        email="joaomaciel.n@gmail.com"
      />
      <div className="title-content">
        <strong className="title">Jon Maciel Neves Sampaio</strong>
        <p className="sub-title">Senior Full-Stack Software Engineer</p>
        <p className="sub-title">
          Ruby on Rails - Elixir - GraphQL - ReactJS - Apollo
        </p>

        <p className="sub-title">
          <AiOutlineMail />
          <a
            className="App-email"
            href="mailto:jon@maciel.dev"
            target="_blank"
            rel="noreferrer"
          >
            jon@maciel.dev
          </a>
        </p>
      </div>
      <div className="App-social">
        <a
          className="App-social-link"
          href="https://www.linkedin.com/in/jonmaciel"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaLinkedin />
        </a>
        <a
          className="App-social-link"
          href="https://github.com/jonmaciel"
          target="_blank"
          rel="noopener noreferrer"
        >
          <AiOutlineGithub />
        </a>
        <a
          className="App-social-link"
          href="https://www.instagram.com/jon_maciel/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FiInstagram />
        </a>
      </div>
      <RiSeparator className="section-separator" />
      <div className="projects">
        <strong className="title">Side Projects</strong>
        <a
          className="App-link"
          href="https://www.hunterquest.fit/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>HunterQuest.fit</span>
          <small className="mobile-project-subtitle">
            Gamified fitness app with AI-generated workouts and RPG-style
            progression.
          </small>
        </a>
        <a
          className="App-link"
          href="https://dindim.digital"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>Dindim.Digital</span>
          <small className="mobile-project-subtitle">
            Mobile App to help parents to teach children financial education.
          </small>
        </a>
        <a
          className="App-link"
          href="https://mathwarrior.app"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>Math Warrior</span>
          <small className="mobile-project-subtitle">
            Web App to help kids on math leaning.
          </small>
        </a>
        <a
          className="App-link"
          href="https://github.com/jonmaciel/smart_promo_api"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>
            <TbApi /> RoR + GraphQL Project Sample
          </span>
          <small className="mobile-project-subtitle">
            API I created to be used as GraphQL sample.
          </small>
        </a>
        <a
          className="App-link"
          href="https://play.google.com/store/apps/details?id=com.unionassets.android.stretchy.slime"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>Stretchy Slime</span>
          <small className="mobile-project-subtitle">
            Android game I developed using Unity.
          </small>
        </a>
      </div>
    </div>
  );
}

export default App;
